export default __webpack_public_path__ + "static/media/menu-news.7e5eaf01.svg";